import './ClaimPromoModal.scss';
import { FormEvent, useState } from "react";
import { promoApiService } from "../../../../../platform/api";
import { promoStore, utilsStore } from "../../../../../platform/stores";
import { useTranslation } from "../../../../../platform/stores/translationStore";
import { observer } from "mobx-react";

export const ClaimPromoModal = observer(() => {
  const [promoCode, setPromoCode] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const t = useTranslation();

  const handleSubmit = async (event: FormEvent) => {
    event.preventDefault();
    setIsLoading(true);
    setError(null);

    if (!promoCode) {
      setError('PROMO_CODE_REQUIRED');
      setIsLoading(false);
      return;
    }

    try {
      await promoApiService.claim(utilsStore.gameId!, promoCode);
      // promoStore.setPromoModalIsOpen(false);
    } catch (err: any) {
      setError(err.message);
      setIsLoading(false);
    } finally {
    }
  };

  return (
    <div className="claim-promo-modal">
      <div className="claim-promo-modal-background" onClick={() => promoStore.setPromoModalIsOpen(false)}></div>
      <div className="claim-promo-modal-content">
        <h1>{t('PROMO_CLAIM_VOUCHER')}</h1>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="promo-code">{t('PROMO_ENTER_CODE')}</label>
            <br/>
            <input
              type="text"
              id="promo-code"
              name="promo-code"
              placeholder={t('PROMO_CODE')}
              value={promoCode}
              onChange={(e) => setPromoCode(e.target.value)}
            />
          </div>
          {error && <p className="error-message">{t(error)}</p>}
          <p className="voucher-text">{t('PROMO_VOUCHER_TEXT')}</p>
          <button type="submit" disabled={isLoading}>
            {isLoading ? <span className="spinner"></span> : t('PROMO_CLAIM')}
          </button>
        </form>
      </div>
    </div>
  );
});